import React, { useEffect, useMemo } from 'react';

import BestOfCategoryIcon from 'app/features/BestOf/presentation/BestOfCategoryIcon';
import { useFormikContext } from 'formik';
import { ThemeProvider } from 'styled-components';

import { useResourceSubmissionFields } from '../hooks/useResourceSubmissionFields';
import { ResourceSubmissionFieldSubtitle, ResourceSubmissionFieldTitle } from '../styled';
import {
  ResourceSubmissionCategoryContainer,
  ResourceSubmissionCategoriesWrapper,
  ResourceSubmissionCategoryWrapper,
  ResourceSubmissionCategoryName,
  ResourceSubmissionCategoryIconContainer,
} from './styled';

export default function ResourceSubmissionCategory({ disabled = false }: { disabled?: boolean }) {
  const formikContext = useFormikContext();
  const { data } = useResourceSubmissionFields();

  const selectedType = data?.resource_submission_categories?.find(
    (category) => category.uuid === formikContext.values['resource_submission_category_uuid']
  )?.resource_type_slug;
  useEffect(() => {
    if (selectedType && formikContext.values['resource_type'] !== selectedType) {
      void formikContext.setFieldValue('resource_type', selectedType, true);
    }
  }, [selectedType, formikContext.values['resource_type']]);

  const handleCategoryClick = (category) => {
    if (disabled) return;
    formikContext.setFieldTouched('resource_submission_category_uuid', true);
    if (formikContext.values['resource_submission_category_uuid'] === category.uuid) {
      formikContext.setFieldValue('resource_submission_category_uuid', null, true);
    } else {
      formikContext.setFieldValue('resource_submission_category_uuid', category.uuid, true);
    }
  };

  const isError = useMemo<boolean>(() => {
    return (
      formikContext.errors['resource_submission_category_uuid'] &&
      formikContext.touched['resource_submission_category_uuid']
    );
  }, [
    formikContext.errors['resource_submission_category_uuid'],
    formikContext.touched['resource_submission_category_uuid'],
  ]);

  return (
    <ThemeProvider theme={{ isError }}>
      <ResourceSubmissionCategoryWrapper>
        <input
          type="hidden"
          name="resource_submission_category_uuid"
          value={formikContext.values['resource_submission_category_uuid']}
        />
        <ResourceSubmissionFieldTitle>Submission Category</ResourceSubmissionFieldTitle>
        <ResourceSubmissionFieldSubtitle isError={isError}>
          {isError ? 'Required. Please select one category.' : 'Required'}
        </ResourceSubmissionFieldSubtitle>
        <ResourceSubmissionCategoriesWrapper>
          {data?.resource_submission_categories?.map((category) => (
            <ResourceSubmissionCategoryContainer
              key={category.uuid}
              type="button"
              disabled={disabled}
              aria-pressed={
                formikContext?.values['resource_submission_category_uuid'] === category.uuid
              }
              active={formikContext?.values['resource_submission_category_uuid'] === category.uuid}
              onClick={() => handleCategoryClick(category)}
            >
              <ResourceSubmissionCategoryIconContainer>
                <BestOfCategoryIcon src={category.icon} />
              </ResourceSubmissionCategoryIconContainer>
              <ResourceSubmissionCategoryName>{category.name}</ResourceSubmissionCategoryName>
            </ResourceSubmissionCategoryContainer>
          ))}
        </ResourceSubmissionCategoriesWrapper>
      </ResourceSubmissionCategoryWrapper>
    </ThemeProvider>
  );
}
